import React, { useState, useEffect, useCallback } from "react";
import {
    TextField,
    Typography,
    Button,
} from "@mui/material";
import {makeStyles, withStyles} from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import axios from "axios";
import { defaultVariables } from "../../../../../config";
import Grid from "@mui/material/Grid2";
import {Styles} from "../../../../../config/design/styles";
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import PassField from "../../../../components/elements/fields/PassField";
import validator from "validator";
import {Asterisk, Mail, Phone} from "lucide-react";


const LoginUserWithPass = ({ user, makeLogin,classes,login_type,handleOtp,wentOTP }) => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [fields, setFields] = useState({ password: "" });
    const [errors, setErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);


    const handleChange = (e) => {
        const { name, value } = e.target;
        let newFields = { ...fields };
        let newErrors = { ...errors };
        newErrors[name] = "";
        newFields[name] = value;

        setFields(newFields);
        setErrors(newErrors);
    };
    const validateFields = () => {
        const newErrors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.password)) {
            formIsValid = false;
            newErrors['password'] = t('emptyPassword');
        }

        setErrors(newErrors);
        return formIsValid;
    };

    const handleRequest = async () => {
        const { password } = fields;
        try {
            const response = await axios.post(
                `${defaultVariables.url}/auth/check-token`,
                {
                    password,
                    user_id: user.id,
                },
                {
                    headers: {
                        Accept: "application/json",
                    },
                }
            );
            makeLogin(response.data);
            setSubmitLoading(false);
        } catch (error) {
            console.log(error.response)
            setSubmitLoading(false);
            enqueueSnackbar(t("wrongPassword"), { variant: "error" });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        if (validateFields()) {
            handleRequest();
        } else {
            setSubmitLoading(false);
        }
    };

    const forgetPass = () => {
        localStorage.setItem("redirect", "/reset-password");
        handleOtp()
    }
    return (
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item size={12}>
                    <PassField
                        fullWidth
                        variant="outlined"
                        name="password"
                        label={t('password')}
                        type="password"
                        onChange={handleChange}
                        error={!!errors['password']}
                        helperText={errors['password']}
                        autoFocus
                    />
                    {
                        !wentOTP &&
                        <Button color="grayDark" size="small" onClick={() => forgetPass()}
                        >
                            {t('doYouForgetPass')}
                        </Button>
                    }
                </Grid>
                <Grid item size={12} >
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth
                        onClick={handleSubmit}
                        loading={submitLoading}
                        style={{width:"100%"}}
                        styleForParent={{margin:"10px 0"}}
                    >
                        {t("confirm")}
                    </LoadingButton>
                </Grid>
                {
                    !wentOTP &&
                    <Grid item size={12} style={{textAlign:"center"}}>
                        <Button color="secondary"
                                startIcon={<Asterisk className="lucide-icon"/>
                        }

                                onClick={() => handleOtp()}
                        >
                            {t('loginWithOTP')}
                        </Button>
                    </Grid>
                }

            </Grid>
        </form>
    );
};
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(LoginUserWithPass));
